import { useState } from 'react';

import {
  AverageLastScoreSpan,
  AveragePlayerScore,
} from '@sorare/core/src/__generated__/globalTypes';
import { TotalAveragePlayerScore } from '@sorare/core/src/lib/averagePlayerScore';

import {
  ALL_VALUE,
  FilterKey,
  Filters,
} from '@sorare/marketplace/src/lib/performance';

const replaceAllValue = (value: string) =>
  value === ALL_VALUE ? undefined : value;

const getAveragePlayerSpanFromScore = (
  score: TotalAveragePlayerScore
): AverageLastScoreSpan =>
  ({
    [AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE]:
      AverageLastScoreSpan.LAST_FIVE,
    [AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE]:
      AverageLastScoreSpan.LAST_TEN,
    [AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE]:
      AverageLastScoreSpan.LAST_FIFTEEN,
    [AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE]:
      AverageLastScoreSpan.LAST_FORTY,
    [AveragePlayerScore.SEASON_AVERAGE_SCORE]: AverageLastScoreSpan.SEASON,
  })[score];

export const usePerformanceFilters = () => {
  const [filters, setFilters] = useState<Filters>({
    [FilterKey.COMPETITION]: ALL_VALUE,
    [FilterKey.TEAM]: ALL_VALUE,
    [FilterKey.HOME_AWAY]: ALL_VALUE,
    [FilterKey.MODE]: AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE,
  });

  const handleFilterChange = (key: FilterKey, value: Filters[FilterKey]) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const gqlFilters = {
    competitionSlug: replaceAllValue(filters[FilterKey.COMPETITION]),
    teamSlug: replaceAllValue(filters[FilterKey.TEAM]),
    location:
      filters[FilterKey.HOME_AWAY] === ALL_VALUE
        ? undefined
        : filters[FilterKey.HOME_AWAY],
    span: getAveragePlayerSpanFromScore(filters[FilterKey.MODE]),
  };

  return { filters, handleFilterChange, gqlFilters };
};
